export function checkIfASCII(val: string): boolean {
  return /^[\x00-\x7F]*$/.test(val);
}

export function normalizeString(name: string): string {
  if (name == null) return null;
  name = name.toUpperCase().trim();
  if (name.trim() !== "." && name.substring(name.length - 1, name.length) === ".") {
    name = name.substring(0, name.length - 1).trim();
  }
  return name;
}


export function checkIfValidHostName(host: string): boolean {
  const DOMAIN_PATTERN = new RegExp(/^([A-Za-z0-9\-]+\.)*[A-Za-z0-9\-]+$/);
  return DOMAIN_PATTERN.test(host);
}

  export function checkIfValueIsHex(value: string): boolean {
  const HEX_PATTERN = new RegExp(/^[0-9A-Fa-f]+$/);
  return HEX_PATTERN.test(value);
}

export function checkIfGiveCharIsNumberOrLetter(char: string): boolean {
  if (char == null || char.trim() === "") {
    return false;
  }
  const letterOrNumber = new RegExp(/^[0-9a-zA-Z]+$/);
  return letterOrNumber.test(char);

}

export function checkIfGivenStringIsNumber(char: string):boolean{
  const numberRegex = new RegExp(/^\d+$/);
  return numberRegex.test(char);
}
